package org.vreo.devicehub.features.core.domain.device.videoCameraConfig

/**
 * Frame rotation. Represents frame rotation.
 */
enum class VideoFrameRotation {
    ROTATE_0,
    ROTATE_90,
    ROTATE_180,
    ROTATE_90_COUNTER_CLOCKWISE,
}